import type {JotaiStore} from 'jotai'

import type {DeliveryInfo, SelectedStoreInformation} from './types'

export function getDefaultDeliveryInfo(): DeliveryInfo {
  return {
    deliveryType: 'delivery', // default
    userAddress: {
      street_addr: '',
      city: '',
      state: '',
      zipcode: '',
      country: '',
      street_addr_2: '',
      latitude: 0,
      longitude: 0,
    },
  }
}
export function getDefaultSelectedStoreInfo(): SelectedStoreInformation {
  return {
    store_info: {
      store_id: '',
      store_description: '',
      store_rating: 0,
      store_rating_count: 0,
      store_address: {
        street_addr: '',
        city: '',
        state: '',
        zipcode: '',
        country: '',
        street_addr_2: '',
        latitude: 0,
        longitude: 0,
      },
      store_cuisine: [],
      store_name: '',
      store_delivery_time: 0,
      store_delivery_distance: 0,
      store_image: [],
      pickup_enabled: true,
      delivery_enabled: true,
    },
  }
}

const deliveryInfoStorage = createJSONStorage<DeliveryInfo>(() => localStorage)
const selectedStoreInfoStorage = createJSONStorage<SelectedStoreInformation>(() => localStorage)

export const deliveryInfoAtom = atomWithStorage<DeliveryInfo>(
  'deliveryInformation',
  getDefaultDeliveryInfo(),
  deliveryInfoStorage,
  {
    getOnInit: true,
  },
)
export const selectedStoreInfoAtom = atomWithStorage<SelectedStoreInformation>(
  'selectedStoreInformation',
  getDefaultSelectedStoreInfo(),
  selectedStoreInfoStorage,
  {
    getOnInit: true,
  },
)

const deliveryTypeAtom = focusAtom(deliveryInfoAtom, optic => optic.prop('deliveryType'))
const addressAtom = focusAtom(deliveryInfoAtom, optic => optic.prop('userAddress'))
const selectedStoreAtom = focusAtom(selectedStoreInfoAtom, optic => optic.prop('store_info'))

export function useDeliveryType() {
  return useAtom(deliveryTypeAtom)
}

export function useUserAddress() {
  return useAtom(addressAtom)
}

export function useSelectedStore() {
  return useAtom(selectedStoreAtom)
}

export function useGetUserAddress(store: JotaiStore) {
  return useCallback(() => store.get(addressAtom), [store])
}

const dropOffNoteStorage = createJSONStorage<string>(() => localStorage)

export const dropOffNoteAtom = atomWithStorage<string>('dropOffNote', '', dropOffNoteStorage, {
  getOnInit: true,
})

export function useDropOffNote() {
  return useAtom(dropOffNoteAtom)
}

export function useSetDropOffNote() {
  return useSetAtom(dropOffNoteAtom)
}

export function useGetDropOffNote() {
  const store = useStore()
  return useCallback(() => store.get(dropOffNoteAtom), [store])
}

const scheduledIdStorage = createJSONStorage<string>(() => localStorage)

export const scheduledIdAtom = atomWithStorage<string>('scheduledId', '', scheduledIdStorage, {
  getOnInit: true,
})

export function useScheduledId() {
  return useAtom(scheduledIdAtom)
}

export function useSetScheduledId() {
  return useSetAtom(scheduledIdAtom)
}

export function useGetScheduledId() {
  const store = useStore()
  return useCallback(() => store.get(scheduledIdAtom), [store])
}
